import { Box, Divider, Grid, Paper, Typography } from '@mui/material'

import ToothGraphic4 from '@/assets/images/Tooth-graphic-4.svg'
import PieChart from '@/components/PieChart'
import {
  ALL_IN_ONE_REGIONS,
  dentinLayerView,
  getAllInOneCeramicBrand,
  getDentinLayerAdvice,
  hasDentinAdvice,
} from '@/utils/matisseV2/allInOne'

const DentinPDF = ({
  recipe,
  dentinCervicalIndex,
  dentinMiddleIndex,
  dentinIncisalIndex,
}) => {
  const brand = getAllInOneCeramicBrand(recipe)
  const indexes = {
    cervical: dentinCervicalIndex,
    middle: dentinMiddleIndex,
    incisal: dentinIncisalIndex,
  }
  const titles = {
    cervical: 'Cervical',
    middle: 'Middle',
    incisal: 'Incisal',
  }

  return (
    <Box
      sx={{
        backgroundColor: '#FFF',
        p: 3,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        color: 'black',
      }}
      id="download-page-2"
    >
      {hasDentinAdvice(recipe) && (
        <>
          <Grid container spacing={2} alignItems="stretch">
            <Grid item xs={4}>
              <Paper
                elevation={0}
                sx={{ backgroundColor: '#FFF', color: '#000', p: 2 }}
              >
                <img
                  src={ToothGraphic4}
                  alt="Toothimage"
                  style={{ width: '233px', height: '330px' }}
                />
              </Paper>
            </Grid>

            <Grid item xs={8} container alignItems="center">
              <Box sx={{ width: '100%' }}>
                <Box display="flex" alignItems="center" m={2}>
                  <Typography
                    variant="h5"
                    component="div"
                    sx={{ marginRight: 2 }}
                  >
                    Dentin:
                  </Typography>
                  {brand && (
                    <Box
                      sx={{
                        backgroundColor: '#F44336',
                        borderRadius: '16px',
                        p: 1,
                      }}
                    >
                      {brand}
                    </Box>
                  )}
                </Box>

                {ALL_IN_ONE_REGIONS.map((region) => {
                  const layerData = getDentinLayerAdvice(recipe, region)
                  if (!layerData) return null
                  const index = indexes[region]
                  return (
                    <Box key={region}>
                      <Divider />
                      <Box my={3}>
                        <Typography>{titles[region]}</Typography>
                        <Grid container spacing={2}>
                          {[
                            layerData.recipe_layer1,
                            layerData.recipe_layer2,
                          ].map((layerItems, layer) => {
                            const item = layerItems?.[index]
                            if (!item) return <Grid item xs={4} key={layer} />
                            const view = dentinLayerView(item)
                            return (
                              <Grid item xs={4} key={layer}>
                                {view.opacityCategory && (
                                  <Typography
                                    textAlign="center"
                                    sx={{
                                      textTransform: 'capitalize',
                                      fontWeight: 'bold',
                                    }}
                                  >
                                    {view.opacityCategory}
                                  </Typography>
                                )}
                                <PieChart
                                  labels={view.names}
                                  values={view.ratios as number[]}
                                />
                              </Grid>
                            )
                          })}
                          <Grid
                            item
                            xs={4}
                            display="flex"
                            justifyContent="flex-end"
                            alignItems="center"
                          >
                            {index + 1}
                          </Grid>
                        </Grid>
                      </Box>
                    </Box>
                  )
                })}

                <Divider />
              </Box>
            </Grid>
          </Grid>
        </>
      )}
    </Box>
  )
}

export default DentinPDF
